import React from "react";
import styled from "styled-components";
import { SpinnerIcon } from "../StyledComponents/PathwayIcons";

const LoadingSpinner = (props) => {
    return (
        <>
            {props.loading && (
                <Wrapper role="status">
                    <SpinnerIcon
                        $size={props.size ? props.size : "var(--iconSize-xl)"}
                        $primary={props.primary === undefined ? true : props.primary}
                    />
                    <span className="visually-hidden">Wird geladen</span>
                </Wrapper>
            )}
        </>
    );
};

export default LoadingSpinner;

const Wrapper = styled.div`
    display: grid;
    align-items: center;
    justify-items: center;
    text-align: center;
    grid-template-columns: 1fr;
    grid-template-rows: 1fr;
`;
